__turbopack_context__.v({
  "btn": "ButtonCollection-module__57mRCa__btn",
  "container": "ButtonCollection-module__57mRCa__container",
  "fadeInItems": "ButtonCollection-module__57mRCa__fadeInItems",
  "spacing--lg": "ButtonCollection-module__57mRCa__spacing--lg",
  "spacing--md": "ButtonCollection-module__57mRCa__spacing--md",
  "spacing--sm": "ButtonCollection-module__57mRCa__spacing--sm",
  "spacing--xl": "ButtonCollection-module__57mRCa__spacing--xl",
  "spacing--xs": "ButtonCollection-module__57mRCa__spacing--xs",
  "spacing--xxl": "ButtonCollection-module__57mRCa__spacing--xxl",
  "spacing--xxs": "ButtonCollection-module__57mRCa__spacing--xxs",
  "spacing--xxxl": "ButtonCollection-module__57mRCa__spacing--xxxl",
  "spacing--xxxs": "ButtonCollection-module__57mRCa__spacing--xxxs",
  "tooltip": "ButtonCollection-module__57mRCa__tooltip",
});
